import { createBrowserRouter } from 'react-router';
import { RouterErrorBoundary, RouterLayout } from './components/RouterLayout';

export const searchRouter = createBrowserRouter(
  [
    {
      Component: RouterLayout,
      ErrorBoundary: RouterErrorBoundary,
      children: [
        {
          path: '/',
          lazy: async () => ({
            Component: (await import('./features/search/routes/search-page')).SearchPage,
          }),
        },
      ],
    },
  ],
  { basename: '/search' },
);
